import { nrkLockActive, nrkMediaPlayFail, nrkMediaTilgjengelighetGeoblocked } from "@nrk/core-icons";
const NonPlayableIcons = {
  nrkLockActiveIcon: nrkLockActive,
  nrkPlayFailIcon: nrkMediaPlayFail,
  nrkGeoblockedIcon: nrkMediaTilgjengelighetGeoblocked,
  "": ""
};
const NO_SUBTITLES = "none";
export {
  NO_SUBTITLES,
  NonPlayableIcons
};
